import React, {ReactNode, useCallback, useMemo} from 'react';
import {Field} from "react-final-form";
import {ErrorInput, KlInputErrors} from "./klInputErrors/klInputErrors.component";
import {validateRequiredTrue} from "../commonOpenSite/validation/basicValidators";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./klTos.component.scss');

interface KlTosProps {
    emailAgreementFieldName: string;
    privacyReadFieldName: string;
    privacyReadFieldValue?: boolean;
    submitClicked?: boolean;
    validatePrivacy?: boolean;
    disabled?: boolean;
    hideEmail?: boolean;
    customTos?: string;
}

export function KlTos(props: KlTosProps) {

    const {emailAgreementFieldName, privacyReadFieldName, privacyReadFieldValue, submitClicked, validatePrivacy,
        disabled, hideEmail, customTos} = props;

    const errors = useMemo((): ErrorInput[] => {
        return [
            {condition: !privacyReadFieldValue, description: `Please agree to terms.`}
        ];
    }, [privacyReadFieldValue]);

    const linkText = useCallback((text: string, link: string): ReactNode => {
        return disabled
            ? <span className={styles.link}>{text}</span>
            : <a className={styles.link} href={link} target={"_blank"}>{text}</a>;
    }, [disabled]);

    return (
        <div className={`${styles.tos} ${disabled ? styles.disabled : ''}`}>
            <KlInputErrors
                errors={errors}
                submitClicked={submitClicked}
                showOnSubmit
            />
            {!hideEmail &&
                <label className={`${styles.label} ${disabled ? styles.defaultCursor : styles.clickableCursor}`}>
                    {disabled
                        ? <div className={styles.disabledCheckbox}/>
                        : <Field type={"checkbox"} name={emailAgreementFieldName} tabIndex={4} validateFields={[]} component={"input"}/>
                    }
                    <div className={styles.text}>
                        I agree to receive emails from Klear
                    </div>
                </label>
            }
            <label htmlFor={"suTosAgreement"} className={`${styles.label} ${disabled ? styles.defaultCursor : styles.clickableCursor}`}>
                {disabled
                    ? <div className={styles.disabledCheckbox}/>
                    : <Field name={privacyReadFieldName}  validate={validatePrivacy ? validateRequiredTrue : undefined}
                               id={"suTosAgreement"} type={"checkbox"} validateFields={[]} component={"input"} tabIndex={5}/>
                }
                    {customTos
                        ?
                            <div className={styles.text}>
                                <div className={styles.customTos} dangerouslySetInnerHTML={{__html: customTos}}/>
                            </div>
                        :
                            <div className={styles.text}>
                                I have read the {linkText('privacy policy', '/legal/privacy/')},
                                and agree to the {linkText('terms of use', '/legal/tou/')}.
                            </div>
                    }
            </label>
        </div>
    );
}
